
export class Vector {
	constructor(
		public X: number,
		public Y: number) {

	}

	public sub(other: Vector): Vector {
		return new Vector(this.X - other.X, this.Y - other.Y);
	}

	public add(other: Vector): Vector {
		return new Vector(this.X + other.X, this.Y + other.Y);
	}

	public mult(other: Vector): Vector {
		return new Vector(this.X * other.X, this.Y * other.Y);
	}

	public equals(other: Vector): boolean {
		if (!other)
			return false;

		if (this == other)
			return true;

		return other.X == this.X && other.Y == this.Y;
	}
}
